<template>
  <div>
    <Button type="primary" @click="modal = true" v-hasPermission="['permissionsConfigurationManagement:group:add_group']">{{ $t('permission_configuration_management.group.addGroup') }}</Button>
    <Modal v-model="modal" :title="$t('permission_configuration_management.group.addGroup')" :loading="loading" @on-ok="groupSubmit('groupsForm')"
           @on-cancel="groupReset('groupsForm')" :mask-closable="false" :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
      <Form ref="groupsForm" :model="groupsForm" :label-width="100" :rules="ruleValidate">
        <!-- 公司 -->
        <div v-if="company == 1">
            <FormItem :label="$t('permission_configuration_management.account.company')" prop="companyId">
                <Select v-model="companyId" style="width:300px;" :placeholder="$t('permission_configuration_management.common.pleaseSelect')">
                    <Option :value="item.id" v-for="(item,index) in companyList" v-bind:key="index">{{item.name}}
                    </Option>
                </Select>
            </FormItem>
        </div>

        <!-- 组名称 -->
        <FormItem :label="$t('permission_configuration_management.group.groupName')" prop="name">
            <Input v-model="groupsForm.name" placeholder="Enter something..." style="width:300px;"></Input>
        </FormItem>

        <!-- 备注 -->
        <FormItem :label="$t('permission_configuration_management.role.remark')" prop="remark">
            <Input v-model="groupsForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..." style="width:300px;"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import TableGroups from '../group/TableGroups.vue'

    var tableGroups = TableGroups;
    export default {
        data() {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                show: false,
                groupsForm: {
                    name: '',
                    remark: ''
                },
                loading: true,
                modal: false,
                ruleValidate: {
                    name: [
                        {required: true, message: this.$t('permission_configuration_management.group.groupNameRequired'), trigger: 'blur'},
                        {type: 'string', message: this.$t('permission_configuration_management.group.groupNameLength'), pattern: '^.{4,20}$', trigger: 'blur'}
                    ]
                }
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
               this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                 .then(res => {
                     this.companyList = res.data;
                 });
             },
            // 确定
            groupSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var updateGroup = {
                            "companyId": this.companyId,
                            "name": this.groupsForm.name,
                            "remark": this.groupsForm.remark
                        };

                        this.$api.group.createGroup(updateGroup)
                            .then(res => {
                                this.data = res.data;
                                setTimeout(() => {
                                    tableGroups.methods.showAll();
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success(this.$t('common.addSuccess'));
                                    this.modal = false;
                                }, 1000);
                            })
                    } else {
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error(this.$t('common.addFail'));
                    }
                });
            },
            // 取消
            groupReset: function (name) {
                this.$refs[name].resetFields();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/group/AddGroups.vue